module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/minus-7262f24fa45e7b26d4b329b305f89b2a.svg";